import { estClient } from './estClient';

class SettingsApi {
  async getApiKey({ reset }: { reset?: boolean } = {}): Promise<string> {
    const response = await estClient.get<{ apiKey: string }>('/api/api_key', {
      query: reset ? { update: 1 } : undefined,
    });

    return response.apiKey;
  }
}

export const settingsApi = new SettingsApi();
